import { useState } from 'react';

/**
 * A hook for keeping track of the state of a toggle
 * @param {boolean} initialState The initial toggle state
 */
const useToggle = initialState => {
  const [isToggled, setIsToggled] = useState(initialState || false);
  const changeToggle = () => setIsToggled(!isToggled);
  return [isToggled, changeToggle];
};

export { useToggle };
//# sourceMappingURL=useToggle.js.map
